import { useMemo, useState } from "react";

function getCurrentMonth() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
}

function printInvoice(invoice) {
  const popup = window.open("", "_blank", "width=900,height=700");
  if (!popup) return;
  popup.document.write(`
    <html><head><title>${invoice.customerName}</title>
    <style>
      body{font-family:Arial,sans-serif;padding:32px;color:#111827}
      table{width:100%;border-collapse:collapse}
      th,td{border:1px solid #d1d5db;padding:8px;text-align:left}
      .muted{color:#6b7280}
    </style></head><body>
      <h1>Rechnungsaufstellung</h1>
      <p><strong>${invoice.customerName}</strong> ${invoice.customerNumber ? `- JTL ${invoice.customerNumber}` : ""}</p>
      <p class="muted">Zeitraum: ${invoice.month || ""}</p>
      ${invoice.data?.html || invoice.data?.sections?.html || ""}
    </body></html>
  `);
  popup.document.close();
  popup.focus();
  popup.print();
}

export default function Rechnungen({ invoices = [], suppliers = [] }) {
  const [customer, setCustomer] = useState("");
  const [month, setMonth] = useState(getCurrentMonth);

  const filteredInvoices = useMemo(
    () =>
      invoices.filter((invoice) => {
        const matchesCustomer = !customer || invoice.customerId === customer || invoice.customerName === customer;
        const matchesMonth = !month || invoice.month === month;
        return matchesCustomer && matchesMonth;
      }),
    [customer, invoices, month]
  );

  return (
    <div className="page-stack">
      <div>
        <p className="eyebrow">Admin</p>
        <h1 className="page-title">Rechnungen</h1>
      </div>

      <section className="card">
        <div className="form-grid columns-2">
          <label className="field">
            <span>Kunde</span>
            <select value={customer} onChange={(event) => setCustomer(event.target.value)}>
              <option value="">Alle Kunden</option>
              {suppliers.map((supplier) => (
                <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
              ))}
            </select>
          </label>
          <label className="field">
            <span>Zeitraum monatlich</span>
            <input type="month" value={month} onChange={(event) => setMonth(event.target.value)} />
          </label>
        </div>
      </section>

      <section className="card">
        <h2>Gespeicherte Rechnungen</h2>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Kunde</th>
                <th>JTL Kundennummer</th>
                <th>Monat</th>
                <th>Status</th>
                <th>Aktualisiert</th>
                <th>Aktion</th>
              </tr>
            </thead>
            <tbody>
              {filteredInvoices.map((invoice) => (
                <tr key={invoice.id} className={invoice.status === "printed" ? "row-processed" : "row-billing-overdue"}>
                  <td>{invoice.customerName}</td>
                  <td>{invoice.customerNumber || "-"}</td>
                  <td>{invoice.month}</td>
                  <td>{invoice.status === "printed" ? "Gedruckt" : "Gespeichert"}</td>
                  <td>{invoice.updatedAt || "-"}</td>
                  <td>
                    <button type="button" className="button button-secondary" onClick={() => printInvoice(invoice)}>
                      Oeffnen / Drucken
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
